<template>
  <!-- AREA DA TABELA INICIO -->
  <div class="px-4 sm:px-6 lg:px-8 mb-12">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-base font-semibold leading-6 text-gray-900">{{ headerInfo.title }}</h1>
        <p class="mt-2 text-sm text-gray-700">{{ headerInfo.description }}</p>
      </div>
      <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex sm:space-x-4">

        <!-- Botões Defaul caso sejam usados -->
        <template v-if="defaultButtons">

          <button 
            @click="sendFormData" 
            type="button" 
            class="block w-full rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Novo 
          </button>
          <button 
            @click="filterOpen"
            type="button" 
            class="block w-full rounded-md bg-customPurple px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Filtro
          </button>
          
        </template>
        <!-- Botões alternativos para o caso de useForms ser false -->
        <template v-else>

          <button 
            @click="filterOpen"
            type="button" 
            class="block w-full rounded-md bg-customPurple px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Filtro
          </button>
          
        </template>
      </div> 
    </div>
        <div class="mt-8 flow-root">
            <div class="-mx-4 -my-2 overflow-x-auto relative sm:-mx-6 lg:-mx-8">
              <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                <table class="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th v-for="header in headersData" :key="header.id" 
                        scope="col" 
                        class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                        {{ header }}
                      </th>
                    <th scope="col" class="sticky acao-coluna-cabecalho  whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-0">
                      <span class="sr-only">Ações</span>
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 bg-white">
                  <tr v-for="data in listingData" :key="data.id" class="hover:bg-gray-100">
                    <template v-for="(value, key) in data" :key="key">
                      <td v-if="key !== 'id' && key !== 'dependente_id'" class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                        {{ value }}
                      </td>
                    </template>
                    <td class="sticky acao-coluna  whitespace-nowrap py-2 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                      <div v-if="useDefaultActions" class="flex-acoes">
                        <button href="#" @click="sendEditingData(data.id, data.tipo || null)" class="text-customPurple hover:text-indigo-900">Editar<span class="sr-only">, {{ data.id }}</span></button>
                        <button v-if="podeDeletar()" @click="deleteData(data.id)" href="#" class="text-customPurple hover:text-indigo-900">Deletar<span class="sr-only">, {{ data.id }}</span></button>
                        <button href="#" @click="viewData(data.id)"  class="text-customPurple hover:text-indigo-900">Visualizar<span class="sr-only">, {{ data.id }}</span></button>
                      </div>
                      <div v-else class="flex-acoes gap-2">
                        <template v-for="(action, index) in customActions" :key="index">
                          <a
                            href="#"
                            class="text-customPurple hover:text-indigo-900"
                            @click.prevent="emitCustomButton(action.name,data)"
                          >
                            {{ action.name }}
                          </a>
                        </template>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="flex justify-between items-center mt-2.5 space-x-4">
          <div class="flex items-center">
            <span class="text-sm text-gray-600">Página {{ currentPage }} de {{ totalPages }} | Total de registros: {{ totalRecords }}</span>
          </div>
          <div class="flex sticky items-center space-x-2">
            <button @click="previousPage" v-if="previous" type="button" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Anterior</button>
            <button @click="nextPage" v-if="next" type="button" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Próximo</button>
            <input type="number" v-model="pageNumber" min="1" :max="totalPages" class="border border-gray-300 rounded-md px-2 py-1 text-sm" placeholder="Ir para..." />
            <button @click="goToPage" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Ir</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  export default {
    name: 'CustomListing',
    async created(){
      
    },
    emits: [
      'previous-page', 
      'next-page', 
      'go-to-page', 
      'find-by-field', 
      'clean-filter',
      'send-form-data',
      'send-editing-data',
      'delete-data-id',
      'view-data',
      'custom-button',
      'filter'
    ],
    props: {
      listingData: {
        type: Array,
        required: false
      },
      headersData: {
        type: Array,
        required: true
      },
      headerInfo: {
        type: Object,
        required: true
      },
      previous: {
        type: String,
        required: true,
      },
      next: {
        type: String,
        required: true,
      },
      currentPage: {
        type: Number,
        required: true,
      },
      totalPages: {
        type: Number,
        required: true,
      },
      totalRecords: {
        type: Number,
        required: true,
      },
      editFormData: {
        type: Object,
        required: false
      },
      customActions: {
        type: Array,
        required: false
      },
      useDefaultActions:{
        type: Boolean,
        required:true
      },
      defaultButtons:{
        type: Boolean,
        required:true
      },
    },
    data() {
      return {
        headerInfoData:this.headerInfo,
        pageNumber: 1,
      };
    },
    methods: {
      previousPage() {
        this.$emit('previous-page', this.previous);
      },
      nextPage() {
        this.$emit('next-page', this.next);
      },
      goToPage() {
        this.$emit('go-to-page', this.pageNumber);
      },
      sendFormData(formData){
        this.$emit('send-form-data', formData);
      },
      sendEditingData(editData,id){
        this.$emit('send-editing-data', editData,id);
      },
      deleteData(id){
        this.$emit('delete-data-id', id);
      },
      filterOpen(){
        this.$emit('filter');
      },
      viewData(){
        this.$emit('view-data');
      },
      emitCustomButton(actionName,data) {
        const payload = { ...data, eventName: actionName };
        this.$emit('custom-button', payload);
      },
      podeDeletar() {
        const user = JSON.parse(window.localStorage.getItem("myUser"));
        const grupos = user?.user?.groups || [];
        const permitidos = ['master', 'roteirizacao', 'gcp-organization-admins'];
        return grupos.some(g => permitidos.includes(g));
      }
    },
    components:{
    }
  }
</script>
<style scoped>
.acao-coluna-cabecalho.acao-coluna {
  position: sticky;
  right: 0;
  z-index: 10;
  text-align: center;
  width: 150px;
}
.acao-coluna {
  position: sticky;
  right: 0;
  z-index: 10;
  text-align: center;
  width: 150px;
  background-color: white;
}
.flex-acoes {
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 8px;
}

</style>